<template>
    <BaseModal
        :isVisible="modalStatus"
        title="Solicitar Carona"
        size="xl"
        @close="close"
    >
        <template v-slot:content>

            <div class="vehicle-header mb-4">
                <div class="row">
                    <div class="col-md-12">
                        Você está respondendo a solicitação de carona de:
                        <strong>{{
                                dataModal.city_destination.description
                                }}</strong>
                        no dia
                        <strong>{{ dataModal.reserve.retreat_date }}</strong>
                    </div>
                    <div class="col-md-12 mt-3">
                        <label
                            for="requester_observation"
                        >Deseja enviar alguma observação ao
                         {{ dataModal.requester.name }}?
                        </label
                        >
                        <textarea
                            name="requester_observation"
                            class="form-control"
                            id="requester_observation"
                            cols="30"
                            rows="10"
                            v-model="dataModal.requested_observation"
                        ></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-right mt-3">
                        <button
                            class="btn btn-default"
                            :disabled="disabled"
                            @click="$emit('change-status', {...dataModal, status: 2}); disabled = true"
                        >
                            Aprovar
                        </button>
                        <button
                            class="btn btn-cancel"
                            :disabled="disabled"
                            @click="$emit('change-status', {...dataModal, status: 3}); disabled = true"
                        >
                            Rejeitar
                        </button>
                    </div>
                </div>
            </div>

        </template>
    </BaseModal>
</template>

<script>
import BaseModal from "../Base/BaseModal.vue";
import VehicleHeader from "../Modals/Checklist/VehicleHeader.vue";
import CheckForm from "../Modals/Checklist/CheckForm.vue";

export default {
    components: {
        BaseModal,
        VehicleHeader,
        CheckForm
    },

    props: {
        modalStatus: {
            type: Boolean,
            default: false
        },
        divergence: {
            type: Object,
            required: true
        },
    },

    emits: ["change-status"],

    data() {
        return {
            observation: '',
            dataModal: {},
            disabled: false
        }
    },

    watch: {
        divergence: {
            handler(newValue) {
                this.disabled = false;
                this.dataModal = newValue;
            },
            immediate: true
        }
    },

    methods: {
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.comment {
    margin-top: 15px;
    background-color: #efefef;
    padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/ResponseRideModal.vue